(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 6547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_AppContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9117);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(214);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);





var NotFound = function NotFound() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_AppContainer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
      src: "/404.png",
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().title404),
      alt: "404 image"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundMessage),
      children: ["The page you are looking for does not exist. ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}), " Sorry :("]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
      href: "/",
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundHeadHome),
      children: "Head home"
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NotFound);
/*
  import Link from "next/link";

const NotFound = () => (
  <div className="flex min-h-screen items-center justify-center bg-[var(--side-bg-color)]">
    <div className="flex h-screen w-screen max-w-[var(--max-width)] flex-col items-center justify-center bg-[var(--app-bg-color)]">
      <img
        src="/illustrations/404-Error-illustration.svg"
        alt="404 image"
        height="250px"
        width="250px"
        className="object-cover"
      />

      <p className="mt-8 max-w-sm text-center text-xl">
        Oops! We couldn't find that page. <br />
        Let's get you back on track.
      </p>

      <Link href="/" prefetch={true}>
        <a className="mt-8 rounded-lg bg-primary px-6 py-4 text-xl">Head home</a>
      </Link>

      <footer className="fixed bottom-10 left-1/2 -translate-x-1/2 transform text-center">
        <small className="opacity-70">
          Illustrations by{" "}
          <a href="https://storyset.com/web" target="_blank" rel="noopener noreferrer">
            Storyset
          </a>
        </small>
      </footer>
    </div>
  </div>
);

export default NotFound;

*/

/***/ }),

/***/ 2748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_Home_MainHome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9271);
/* harmony import */ var _components_Loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(313);
/* harmony import */ var _contexts_StoreDataContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(818);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(214);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _404__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6547);
/* harmony import */ var _500__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7486);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5893);










function Home() {
  var context = (0,_contexts_StoreDataContext__WEBPACK_IMPORTED_MODULE_4__/* .useStoreContext */ .Q)();
  var store = context === null || context === void 0 ? void 0 : context.storeData;
  var theme = context === null || context === void 0 ? void 0 : context.themeData;
  var error = context === null || context === void 0 ? void 0 : context.error;
  var storeUrl = context === null || context === void 0 ? void 0 : context.storeUrl;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      loading = _useState[0],
      setLoading = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (store !== null) {
      setLoading(false);
    }
  }, [store]);
  if (error && error.code === 500) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_500__WEBPACK_IMPORTED_MODULE_6__["default"], {});
  if (error && error === 404) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_404__WEBPACK_IMPORTED_MODULE_5__["default"], {});
  if (!store || loading) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Loader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}); // below is the old code for the using pageProps when we were using getServerSideProps
  // const { storeData: store, storeUrl, error, themeData: theme } = props;
  // if (error && error.code === 500) return <Error500Page />;
  // if (error && error === 404) return <NotFound />;
  // if (!store) return <LoaderComponent />;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_8___default().container),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("title", {
        children: (store === null || store === void 0 ? void 0 : store.storeName) || "DM2Buy Store"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        name: "title",
        content: (store === null || store === void 0 ? void 0 : store.storeName) || "DM2Buy Store"
      }), store !== null && store !== void 0 && store.facebookDomainVerificationId ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        name: "facebook-domain-verification",
        content: store === null || store === void 0 ? void 0 : store.facebookDomainVerificationId
      }) : "", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        name: "description",
        content: (store === null || store === void 0 ? void 0 : store.storeBio) || "Online store powered by DM2Buy"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("link", {
        rel: "icon",
        href: "/favicon.ico"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("link", {
        href: "/fonts/fonts.css",
        rel: "stylesheet"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("link", {
        href: "https://fonts.googleapis.com/css2?family=Roboto:wght@700;900&family=Roboto:wght@400;700&display=swap",
        rel: "stylesheet"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1,user-scalable=0"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        property: "og:title",
        content: (store === null || store === void 0 ? void 0 : store.storeName) || "DM2Buy Store"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        property: "og:description",
        content: (store === null || store === void 0 ? void 0 : store.storeBio) || "Online store powered by DM2Buy"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        property: "og:image",
        content: store !== null && store !== void 0 && store.logo ? "https:" + store.logo : "/favicon.ico"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        property: "og:site_name",
        content: "dm2buy"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        property: "og:url",
        content:  true ? window.location.href : 0
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        name: "twitter:card",
        content: "summary"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        name: "twitter:url",
        content:  true ? window.location.href : 0
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        name: "twitter:title",
        content: (store === null || store === void 0 ? void 0 : store.storeName) || "DM2Buy Store"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        property: "twitter:description",
        content: (store === null || store === void 0 ? void 0 : store.storeBio) || "Online store powered by DM2Buy"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        property: "twitter:image",
        content: "https:" + (store === null || store === void 0 ? void 0 : store.logo) || 0
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Home_MainHome__WEBPACK_IMPORTED_MODULE_2__/* .MainHome */ .q, {
      store: store,
      theme: theme
    })]
  });
}

/***/ }),

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2748);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3365,509,1653,8391,296,7473,5407,7333,1607,6352,9096,7835,1191,932,5579,3079,3388,6893,9271,9774,2888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);